<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <!-- <div class="app-logo">
      <router-link to="/">
        <img src="@/assets/keysuperlotto.png">
      </router-link>
    </div> -->
    <MemberProfile />
    <RoundPayrate />
  </CSidebar>
</template>

<script>
import MemberProfile from './MemberProfile'
import RoundPayrate from '@/views/PlayLotto/components/RoundPayrate'

export default {
  name: 'TheSidebar',
  components: {
    MemberProfile,
    RoundPayrate
  },
  //nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>
<style lang="scss">
.app-logo {
  img {
    max-width: 100%;
  }
}
</style>
